import commonService from "./common-service";

class PriceMatchService {
  async getPriceMatchData(payor, group, unique) {
    try {
      const response = await commonService.getFromServer("EOM/PriceMatch", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createData(params) {
    try {
      let response = await commonService.postToServer("EOM/PriceMatch", params);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/PriceMatch/Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadDocument(params) {
    try {
      await commonService.downloadFromServer("EOM/PriceMatch/Download", {
        fileName: "PriceMatch.xlsx",
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateData(params) {
    try {
      let response = await commonService.updateToServer(
        "EOM/PriceMatch/" + params?.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getData(id) {
    try {
      const response = await commonService.getFromServer(
        "EOM/PriceMatch/" + id,
        {}
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteData(id) {
    try {
      const response = await commonService.deleteToServer(
        "EOM/PriceMatch/" + id,
        {}
      );

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting data");
      }
    } catch (e) {
      throw new Error("Error deleting data");
    }
  }
}
export default new PriceMatchService();
